import axios from 'axios';
import db from '../../firebase/firebaseconfig';

import appStore from "@/store/app.store";


import config from "@/config.js";

const paymentLogRef = db.firestore().collection('paymentLog');
const lowDocumentLog = db.firestore().collection('lowDocumentLog');

export const createPaymentLogDB = async (data) => {
    try {
      const result = await paymentLogRef.add(data);
      return result;
    } catch (error) {
      console.log(error)
    }
}

export const updatePaymentLogDB = async (data) => {
  const docId = data.paymentLogId
  try {
    await paymentLogRef.doc(docId).update(data)
  } catch (error) {
    console.log(error);
  }
}

export const createLogDownloadDocumentRBX = (response,  documentNumber, idTransaction) => {

  const {status, error_code, error_description, result:{receipt_id}} = response

  const data = {
    status, 
    error_code, 
    error_description, 
    receipt_id,
    documentNumber, 
    idTransaction
  }

  lowDocumentLog.add(data);
}

export const downloadDocumentBDRbx = async (documentPaymentForShipping, docId, documentPayment, documentNumber, idTransaction) =>  {
  const paymentLogId = docId;
  
  for (const document of documentPaymentForShipping) {

    const payload = {
      "document_payment":
        {
          "payment_type": document.payment_type,
          "document_id": document.document_id, 
          "document_historic_id": document.document_historic_id, 
          "payment_account_id": document.payment_account_id,
          "payment_historic_id": document.payment_historic_id,
          "payment_date": document.payment_date,
          "payment_credit_date": document.payment_credit_date,
          "payment_discount_type": document.payment_discount_type,
          "payment_discount_amount": document.payment_discount_amount,
          "payment_interest_type": document.payment_interest_type,
          "payment_interest_amount": document.payment_interest_amount,
          "payment_fine_type": document.payment_fine_type,
          "payment_fine_amount": document.payment_fine_amount,
          "rate_amount": document.rate_amount,
          "rate_historic_id": document.rate_historic_id,
          "rate_currency_id": document.rate_currency_id,
          "payment_comment": document.payment_comment,
          "unblock_customer": document.unblock_customer
        }
      }

    try {
      const response = await axios.post(`${config.urlApiTely}/low_document_payment_rbx`, payload);

      appStore.commit('handleDownloadDocumentRBX');

      createLogDownloadDocumentRBX(response.data, documentNumber, idTransaction);

      if (response.data.status === 0){
        updatePaymentLogDB({delivered: false, paymentLogId})

        axios.post(`${config.urlApiTely}/low_document_payment_admin`, documentPayment);

        return
      }

      updatePaymentLogDB({delivered: true, paymentLogId})


    } catch (error) {
      updatePaymentLogDB({delivered: false, paymentLogId})
  
      axios.post(`${config.urlApiTely}/low_document_payment_admin`, documentPayment);
      
      console.log(error);
    }
  }

}